import { render, staticRenderFns } from "./ModalDetalhe.vue?vue&type=template&id=45c07f0e&"
import script from "./ModalDetalhe.vue?vue&type=script&lang=js&"
export * from "./ModalDetalhe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports